import { Button } from "antd";
import React from "react";
import { useNavigate } from "react-router-dom";

const EmptySection = ({
  imgSrc = "/assets/icons/empty-removebg-preview.png",
  noDataText = "Data",
  entireText = "",
  navCallBack,
  navLink,
  btnText,
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navLink && navigate(navLink);
    navCallBack && navCallBack();
  };

  return (
    <div className="flex flex-col items-center justify-center text-center mt-3 w-full">
      <div className="bg-white rounded-2xl shadow-sm p-10 flex flex-col items-center w-full">
        <img src={imgSrc} alt="No data" className="w-44 h-44 object-contain mb-6 opacity-90" />
        <h2 className="text-2xl md:text-3xl text-gray-800 font-abhaya font-medium mb-4">
          {entireText ? entireText : `${noDataText} not found!`}
        </h2>
        {(navLink || navCallBack) && (
          <Button
            type="primary"
            size="large"
            onClick={handleClick}
            className="mt-2 px-8 py-5 text-lg rounded-xl"
          >
            {btnText || "Add New"}
          </Button>
        )}
      </div>
    </div>
  );
};

export default EmptySection;
